/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Allocatee_Type_TeamInputs */

const en_admin_allocation_form_allocatee_type_team = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const de_admin_allocation_form_allocatee_type_team = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const es_admin_allocation_form_allocatee_type_team = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const fr_admin_allocation_form_allocatee_type_team = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe`)
};

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */
const it_admin_allocation_form_allocatee_type_team = en_admin_allocation_form_allocatee_type_team;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_allocatee_type_team = en_admin_allocation_form_allocatee_type_team;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */
const pl_admin_allocation_form_allocatee_type_team = en_admin_allocation_form_allocatee_type_team;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */
const hu_admin_allocation_form_allocatee_type_team = en_admin_allocation_form_allocatee_type_team;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_TeamInputs) => LocalizedString} */
const ro_admin_allocation_form_allocatee_type_team = en_admin_allocation_form_allocatee_type_team;

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Admin_Allocation_Form_Allocatee_Type_TeamInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_allocatee_type_team = /** @type {((inputs?: Admin_Allocation_Form_Allocatee_Type_TeamInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Allocatee_Type_TeamInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "de") return de_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "es") return es_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "fr") return fr_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "it") return it_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "pl") return pl_admin_allocation_form_allocatee_type_team(inputs)
	if (locale === "hu") return hu_admin_allocation_form_allocatee_type_team(inputs)
	return ro_admin_allocation_form_allocatee_type_team(inputs)
});
export { admin_allocation_form_allocatee_type_team as "admin.allocation_form.allocatee_type_team" }